import { useState } from 'react'

type Save = (event: { name: string; value: string }) => void

// section toggles default to on in the database
const useSectionToggle = ({
  name,
  initialValue,
  save,
}: {
  name: string
  initialValue: boolean | undefined
  save: Save
}) => {
  const [isOn, setIsOn] = useState(initialValue ?? true)

  const onToggle = () => {
    const next = !isOn
    setIsOn(next)
    save({ name, value: String(next) })
  }

  return { name, isOn, onToggle }
}

export default useSectionToggle
